const setdecimal = (val, num) => {
  let isNegative = false;
  if (
    val == "-0" ||
    val == "-0." ||
    val == "-0.." ||
    val == "-0.0" ||
    Number(val) < 0
  ) {
    isNegative = true;
  }
  val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
  val = val.replace(/^\./g, ""); //验证第一个字符是数字而不是
  val = val.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  val = val
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  switch (num) {
    case 1:
      val = val.replace(/^(\\-)*(\d+)\.(\d).*$/, "$1$2.$3"); //只能输入一个小数
      break;
    case 2:
      val = val.replace(/^(\\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      break;
    case 3:
      val = val.replace(/^(\\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3"); //只能输入三个小数
      break;
    case 4:
      val = val.replace(/^(\\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3"); //只能输入四个小数
      break;
    default:
      val = val.replace(/^(\\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      break;
  }
  if (isNegative) {
    val = "-" + val;
  }
  return val;
};

const limitdecimal = {
  inserted(el, binding, vnode) {
    /**
     * 注意：分页后使用 需要再列表中绑定key值
     * 数字格式化，
     * 以上方法都已去掉精度
     * 使用方法如下：
     * v-limitdecimal.one 两位小数
     * v-limitdecimal.two 两位小数
     * v-limitdecimal.three 三位小数
     * v-limitdecimal.four 三位小数
     *
     * 特别需要注意的是：
     * 1. 如果vnode.data.model存在，类似于element ui 组件的 el-input，不能直接使用e.target.value 去赋值，要不然表面上是格式化
     * 了数字，但是实际提交的数字还是未格式化的，可以用vnode.data.model.callback(value)去赋值
     * 2. 如果自己写的input，可以直接使用e.target.value 去赋值
     */
    el.diyKeyupEvent = e => {
      const { modifiers } = binding;
      const { value } = e.target;
      let val = 0; // 默认值为0
      const valIsNaN = isNaN(parseInt(value, 10)); // 如果是NaN, 设置为0
      if (!valIsNaN) {
        if (modifiers.one) {
          val = setdecimal(value, 1);
          // val = Number(val).toFixed(1);
        }
        if (modifiers.two) {
          val = setdecimal(value, 2, modifiers.negative);
          // val = Number(val).toFixed(2);
        }
        if (modifiers.three) {
          val = setdecimal(value, 3);
          // val = Number(val).toFixed(3);
        }
        if (modifiers.four) {
          val = setdecimal(value, 4);
          // val = Number(val).toFixed(4);
        }
      }
      if (modifiers.negative && value === "-") {
        val = "-";
      }
      /**
       * 1. 如果vnode.data.model存在，类似于element ui 组件的 el-input，不能直接使用e.target.value 去赋值，要不然表面上是格式化
       * 了数字，但是实际提交的数字还是未格式化的，可以用vnode.data.model.callback(value)去赋值
       * 2. 如果自己写的input，可以直接使用e.target.value 去赋值
       */
      if (!value) {
        val = "";
      }
      if (vnode.data.model) {
        vnode.data.model.callback(val);
        e.target.value = val;
      } else {
        e.target.value = val;
      }
    };
    el.diyChangeEvent = e => {
      const { modifiers } = binding;
      const { value } = e.target;
      let val = 0; // 默认值为0
      const valIsNaN = isNaN(parseInt(value, 10)); // 如果是NaN, 设置为0
      if (!valIsNaN) {
        if (modifiers.one) {
          val = setdecimal(value, 1);
          val = Number(val).toFixed(1);
        }
        if (modifiers.two) {
          val = setdecimal(value, 2);
          val = Number(val).toFixed(2);
        }
        if (modifiers.three) {
          val = setdecimal(value, 3);
          val = Number(val).toFixed(3);
        }
        if (modifiers.four) {
          val = setdecimal(value, 4);
          val = Number(val).toFixed(4);
        }
      }
      /**
       * 1. 如果vnode.data.model存在，类似于element ui 组件的 el-input，不能直接使用e.target.value 去赋值，要不然表面上是格式化
       * 了数字，但是实际提交的数字还是未格式化的，可以用vnode.data.model.callback(value)去赋值
       * 2. 如果自己写的input，可以直接使用e.target.value 去赋值
       */
      if (vnode.data.model) vnode.data.model.callback(val);
      else {
        e.target.value = val;
      }
    };
    el.addEventListener("keyup", el.diyKeyupEvent);
    el.addEventListener("change", el.diyChangeEvent);
  },
  update(el) {},
  unbind(el) {
    el.removeEventListener("keyup", el.diyKeyupEvent);
    el.removeEventListener("change", el.diyChangeEvent);
  }
};

export default limitdecimal;
